import { render } from "./propmt-popup.vue?vue&type=template&id=1b1da714"
import script from "./propmt-popup.vue?vue&type=script&lang=js"
export * from "./propmt-popup.vue?vue&type=script&lang=js"

import "./propmt-popup.vue?vue&type=style&index=0&id=1b1da714&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__